import {Basic} from "./Basic";
import {Load} from "./Load";
import {Modal} from "./Modal";

export class Form
{
    constructor(el)
    {
        this.form = el;
        this.form.classList.add('active');
        this.formId = parseInt(el.dataset.formId);
        this.submitted = false;

        this.add_events();

        // toggle conditions based on checked state
        const checkboxes = this.form.querySelectorAll('.w__input--checkbox[data-f="form-toggle-condition"]');
        for(let i=0; i<checkboxes.length; i++)
        {
            Form.toggle_condition(checkboxes[i]);
        }

        Form.check_required(this.form.querySelector('.w__button--submit'),false);
    }

    add_events()
    {
        this.form.addEventListener('keyup', e =>
        {
            const el = e.target;
            if(el.dataset.required === "1")
            {
                if(el.type === 'number')
                {
                    let value = el.value;

                    if(el.min && parseInt(value) < parseInt(el.min))
                    {
                        value = el.min;
                    }
                    else if(el.max && parseInt(value) > parseInt(el.max))
                    {
                        value = el.max;
                    }

                    el.value = value;
                }

                el.closest('.w__input--container').classList.remove('mod--error');
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    Form.check_required(el,false)
                },250);
            }
        });

        this.form.addEventListener('change', e =>
        {
            const el = e.target;
            if(el.dataset.required === "1")
            {
                Form.check_required(el,false)
            }
        });

        this.form.addEventListener('submit', async e =>
        {
            e.preventDefault();
            if(this.submitted === false)
            {
                this.submitted = true;
                await this.process_submit(e.target);
            }
        });
    }

    static add_file(filePicker)
    {
        const container = filePicker.closest('.w__input--upload-container'),
              addButton = filePicker.closest('.w__input--upload-add');

        if(filePicker.files.length > 0) // && this.uploading === false)
        {
            const myFile = filePicker.files[0];

            filePicker.value = '';

            if(container.querySelector('.w__upload--preview-image[data-filename="' + myFile.name + '"]'))
            {
                new Modal("Sie haben bereits ein Bild mit diesem Dateinamen ausgewählt.",true);
            }
            else if(!myFile.type.match('(image/(jpeg|jpg|png|gif|bmp|webp))'))
            {
                new Modal("Es können nur Bilder vom Typ JPEG (JPG), PNG, GIF, WEBP oder BMP hochgeladen werden.",true);
            }
            else if(myFile.size/1024/1024 > 8)
            {
                new Modal("Die Datei ist zu groß. Bitte laden Sie Bilder mit weniger als 8 MB hoch.",true);
            }
            else
            {
                const myReader = new FileReader();
                myReader.addEventListener('load',e =>
                {
                    const myImg = new Image;
                    myImg.src = e.target.result.toString();
                    myImg.data = myFile;
                    myImg.dataset.filename = myFile.name;
                    myImg.addEventListener('load',() =>
                    {
                        /*
                        const mySize = document.createElement('span');
                        mySize.classList.add('w__upload--preview-size');
                        mySize.textContent = myImg.width + 'x' + myImg.height + ' Pixel';
                        mySize.dataset.filename = myFile.name;
                        */

                        const myDelete = document.createElement('button');
                        myDelete.textContent = 'entfernen';
                        myDelete.classList.add('w__button');
                        myDelete.classList.add('w__js-button');
                        myDelete.classList.add('w__upload--preview-delete');
                        myDelete.dataset.f = 'remove-file';
                        myDelete.dataset.filename = myFile.name;

                        myImg.classList.add('w__upload--preview-image');
                        addButton.insertAdjacentElement('beforebegin', myDelete);
                        addButton.insertAdjacentElement('beforebegin', myImg);
                        //addButton.insertAdjacentElement('beforebegin', mySize);
                    });
                });
                myReader.readAsDataURL(myFile);
            }
        }
    }

    static display_confirmation(r)
    {
        document.getElementById('w--main').innerHTML = r['html'];
        if(r['setLoginActive'] === true)
        {
            document.body.querySelector('.w__nav--link.mod--user').classList.add('active');
        }
        document.documentElement.scrollTo(0,0);
    }

    static remove_file(el)
    {
        const elements = el.closest('div').querySelectorAll('[data-filename="' + el.dataset.filename + '"]');
        elements.forEach(element => {
            element.remove();
        });
    }

    async process_submit(el)
    {
        if(Form.check_required(el,true))
        {
            const myModal = new Modal();

            await this.process_upload(myModal);

            myModal.add_textElement('Das Formular wird verschickt. Bitte warten Sie noch einen Moment.',true);

            const data = this.gather_data();

            Load.post(
                document.location.pathname,
                {
                    f: 'form',
                    action: 'submit',
                    formId: this.formId,
                    isPosted: 1,
                    images: this.uploadedImages,
                    fields: data}).then(r =>
            {
                this.submitted = true;
                myModal.remove();

                // login wvk
                if((this.formId === 2 || this.formId === 8) &&
                   data['seller'] && data['seller'] === "Ja" &&
                   r['redirect'])
                {
                    document.location = r['redirect'];
                }
                // custom address on delivery
                else if(this.formId === 7)
                {
                    Basic.delivery.update_customAddress(data, r['html'])
                }
                else
                {
                    Form.display_confirmation(r);
                }
            }).catch(r =>
            {
                myModal.remove();
                new Modal(r['html'],true);
                this.submitted = false;
            });
        }
        else
        {
            this.submitted = false;
        }
    }

    async process_upload(myModal)
    {
        const images = this.form.querySelectorAll('.w__upload--preview-image');
        this.uploadedImages = [];
        if(images.length > 0)
        {
            myModal.add_textElement('Bilder werden hochgeladen:');
            const imgNo = myModal.add_textElement('1/' + images.length) ,
                  imgProgress = myModal.add_textElement('0 %' + images.length);

            for(let i=0; i<images.length; i++)
            {
                imgNo.textContent = (i + 1).toString() + '/' + images.length;
                const prefix = 'bsp_' + Date.now() + '_';
                if(await Load.upload(images[i].data, prefix, imgProgress))
                {
                    this.uploadedImages[i] = prefix + images[i].data.name
                }
            }
        }
    }

    gather_data()
    {
        const fields = this.form.querySelectorAll('input,select,textarea'),
              data = {};
        let el;

        for(let i=0; i<fields.length; i++)
        {
            el = fields[i];
            switch(el.type)
            {
                case 'radio':
                case 'checkbox':
                    if(el.checked)
                    {
                        data[el.name] = el.value;
                    }
                    break;

                default:
                    data[el.name] = el.value.trim();
                    break;
            }
        }

        return data;
    }

    static check_post_code(field)
    {
        const matches = field.value.match(/([0-9]+)/);
        let value = 'D-',
            ok = false;

        if(matches)
        {
            value += matches[0];
        }

        if(value !== field.value)
        {
            field.value = value;
        }

        let cityEl;

        switch(field.name)
        {
            case 'post_code':
                cityEl = field.closest('.w__form').querySelector('.w__input[name="city"]');
                break;

            case 'delivery_post_code':
                cityEl = field.closest('.w__form').querySelector('.w__input[name="delivery_city"]');
                break;
        }

        if(field.value.match(/^D-[0-9]{5}$/))
        {
            ok = true;

            if(cityEl)
            {
                Load.post('user',{f: 'get-city', code: field.value}).then(r => {
                    cityEl.value = r['html'];
                }).catch(() => {
                    cityEl.value = '';
                })
            }
        }
        else if(cityEl)
        {
            cityEl.value = '';
        }

        return ok;
    }

    static check_required(el, markErrors)
    {
        let ok = true;
        const form = el.closest('form'),
              requiredFields = form.querySelectorAll('input[data-required="1"],select[data-required="1"],textarea[data-required="1"]'),
              submitButton = form.querySelector('.w__button--submit')

        for(let i=0; i<requiredFields.length; i++)
        {
            let error = false;

            if(Form.check_value(requiredFields[i]) === false)
            {
                error = true;
            }

            if(error === true)
            {
                const parentEl = requiredFields[i].closest('.w__input--container');
                if(parentEl)
                {
                    if(markErrors)
                    {
                        parentEl.classList.add('mod--error');
                    }

                    if(ok === true)
                    {
                        ok = false;
                        if(markErrors)
                        {
                            parentEl.scrollIntoView();
                        }
                    }
                }
            }
        }

        if(ok === true)
        {
            submitButton.classList.remove('inactive');
        }
        else
        {
            submitButton.classList.add('inactive');
        }

        return ok;
    }

    static check_value(el)
    {
        let ok;

        if(el.dataset.f === 'check-post-code')
        {
            ok = Form.check_post_code(el);
        }
        else
        {
            switch(el.type)
            {
                case 'radio':
                    ok = false;
                    const radios = el.closest('.w__input--radio-container')
                        .querySelectorAll('.w__input--radio[name="' + el.name + '"]');
                    for(let i = 0; i < radios.length; i++)
                    {
                        if(radios[i].checked)
                        {
                            ok = true;
                        }
                    }
                    break;

                case 'checkbox':
                    ok = !!el.checked;
                    break;

                case 'email':
                    ok = Form.valid_email(el.value.trim());
                    break;

                case 'number':
                    ok = ((el.min && parseInt(el.value) >= parseInt(el.min)) ||
                        (!el.min && parseInt(el.value) > 0));
                    break;

                case 'password':
                    ok = (el.value.trim().length >= 4);
                    if(ok && el.closest('.w__input--container').classList.contains('mod--check-complexity'))
                    {
                        ok = (el.value.trim().length >= 8) &&
                            !!el.value.match(/[0-9]/) &&
                            !!el.value.match(/[a-z]/) &&
                            !!el.value.match(/[A-Z]/);
                    }
                    break;

                default:
                    ok = !!el.value.trim();
                    break;
            }
        }

        return ok;
    }

    static toggle_condition(el)
    {
        const fields = el.closest('form')
            .querySelectorAll('.w__input--container[data-conditional-field="' + el.name + '"]');

        if(el.checked)
        {
            for(let i=0; i<fields.length; i++)
            {
                const myInput = fields[i].querySelector('.w__input,.w__input--checkbox,.w__input--radio');

                if(fields[i].dataset.conditionalInvert === '1')
                {
                    fields[i].classList.add('mod--off');
                    myInput.removeAttribute('required');
                    myInput.dataset.required = '';
                    if(myInput.classList.contains('w__input--text') ||
                       myInput.classList.contains('w__input--textarea'))
                    {
                        myInput.value = '';
                    }
                }
                else
                {
                    fields[i].classList.remove('mod--off');
                    if(fields[i].classList.contains('mod--required'))
                    {
                        myInput.setAttribute('required','1');
                        myInput.dataset.required = '1';
                    }
                }
            }

            if(el.dataset.alternative)
            {
                const altEl = el.closest('form')
                    .querySelector('.w__input--checkbox[name="' + el.dataset.alternative + '"]');
                if(altEl && altEl.checked)
                {
                    altEl.checked = false;
                    Form.toggle_condition(altEl);
                }
            }
        }
        else
        {
            for(let i=0; i<fields.length; i++)
            {
                const myInput = fields[i].querySelector('.w__input');

                if(fields[i].dataset.conditionalInvert === '1')
                {
                    fields[i].classList.remove('mod--off');
                    if(fields[i].classList.contains('mod--required'))
                    {
                        myInput.setAttribute('required','1');
                        myInput.dataset.required = '1';
                    }
                }
                else
                {
                    fields[i].classList.add('mod--off');
                    myInput.removeAttribute('required');
                    myInput.dataset.required = '';
                    if(myInput.classList.contains('w__input--text') ||
                       myInput.classList.contains('w__input--textarea'))
                    {
                        myInput.value = '';
                    }
                }
            }
        }

        Form.check_required(el,false);
    }

    static valid_email(email)
    {
        const reg = /^([A-Za-z\d_\-.])+@([A-Za-z\d_\-.])+\.([A-Za-z]{2,8})$/;
        return reg.test(email);
    };
}